<!--
 * @Descripttion: 德运通天然气管理系统
 * @version: 1.0.0
 * @Author: xst
 * @Date: 2020-03-31 13:00:48
 * @LastEditors: xst
 * @LastEditTime: 2020-05-28 10:12:49
 -->
<template>
  <div id="login">
    <div class="loginBox">
      <div class="loginCon">
        <div class="logo-box">
          <img src="../../assets/logo.png" />
        </div>
        <!-- <p class="title"></p> -->
        <div class="login-con-box">
          <div class="title">天然气运营管理系统</div>
          <div class="login-module" >
            <div class="clearfix formTitlt">密码登录</div>
            <el-form :model="loginForm" status-icon label-width="100px" class="demo-ruleForm" >
              <el-form-item>
                <el-input type="text" v-model.trim="loginForm.username" prop='username' auto-complete="off" placeholder="请输入登录账号"></el-input>
              </el-form-item>
              <el-form-item>
                <el-input prop='password' type="password" v-model="loginForm.password" auto-complete="off" placeholder="请输入登录密码" @keyup.enter.native = 'submitForm'></el-input>
              </el-form-item>
              <el-form-item>
                <el-button class="subBtn" type="primary" @click="submitForm">登录</el-button>
              </el-form-item>
              <p class="smalltxt">
                <a class="forget" @click="openForget">忘记密码</a>
                <!--<router-link class="a" to="#">忘记会员名</router-link>-->
                <!--<router-link class="a" to="#">免费注册</router-link>-->
              </p>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <div style="color: #ccc; position: absolute; left: 20px; bottom: 0px;">
      <p style="margin: 14px 0;">Copyright © 2020 苏州德运通信息科技有限公司</p>
    </div>
    <!--忘记密码，找回密码 pop-->
    <el-dialog  :close-on-click-modal="false" title="找回密码" :visible.sync="formDialog" class="backPassword"  v-el-drag-dialog width="400px" >
      <el-form label-width="110px" :model="form" :rules='forget' ref='formforget' @submit.native.prevent @keyup.enter.native='onSubmit("formforget")'>
        <el-form-item prop='username' label-width="0">
          <el-input v-model.trim="form.username" placeholder="请输入登录账号" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item prop='email' label-width="0">
          <el-input v-model.trim="form.email" placeholder="请输入邮箱" maxlength="50">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
              <el-button @click="formDialog = false">取 消</el-button>
              <el-button type="primary" @click='onSubmit("formforget")'>提 交</el-button>
            </span>
    </el-dialog>
  </div>
</template>
<script>
  import api from '@/ajax/api'
  import store from "../../vuex";
  import router from "../../router";
export default {
  data() {
    return {
      smdl: true,
      loginForm: {
        username: "",
        password: ""
      },
      formDialog: false,
      forget:{
        username:[
          {required: true, trigger: "blur", message: "请输入登录账号"}
        ],
        email:[
          {required: true, trigger: "blur", message: "请输入邮箱"},
          { pattern:/^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/, message: '请输入正确的邮箱格式'}
        ],
      },
      form: {
        email: '',
        username: ''
      },
    }
  },
  watch:{
  },
  methods: {
    submitForm() {
      let that = this;
      if (this.loginForm.username === "" ) {
        const h = this.$createElement;
        this.$notify({
          title: "提示信息",
          message: h("i", { style: "color: #E6A23C" }, "请输入您的账号"),
          duration: 2000
        });
        return false;
      }else if(this.loginForm.password === ""){
        const h = this.$createElement;
        this.$notify({
          title: "提示信息",
          message: h("i", { style: "color: #E6A23C" }, "请输入您的密码"),
          duration: 2000
        });
        return false;
      }else {
        let data = {
          client_id:'browser',
          client_secret:'browser',
          grant_type:'password',
          username: this.loginForm.username,
          password: this.loginForm.password
        };
        const url = api.uaa.token+'?client_id='+data.client_id+'&client_secret='+data.client_secret+'&grant_type='+data.grant_type+'&username='+data.username+'&password='+data.password;
        localStorage.clear();
        sessionStorage.clear();
        that.$store.dispatch('setToken', '')
        that.$axios
          .post(url,{})
          .then(res => {
            if(res.data.code==200){
              localStorage.setItem("infor", JSON.stringify(res.data.result));
              localStorage.setItem("token", res.data.result.access_token);
              localStorage.setItem("compId", res.data.result.compId);
              localStorage.setItem("ShortName", res.data.result.companyShortName);
              localStorage.setItem("companyCode", res.data.result.companyCode);
              localStorage.setItem("staffId", res.data.result.staffId);
              localStorage.setItem("departName", res.data.result.departName);
              that.$store.dispatch('setAccountId',res.data.result.accountId)
              that.$store.dispatch('setStaffName',res.data.result.staffName)
              that.$store.dispatch('setRoleName',res.data.result.roleName)
              that.$store.dispatch('setCompanyShortName',res.data.result.companyShortName)
              that.$store.dispatch('setToken', res.data.result.access_token).then(() => {
              that.$router.push({path: '/'});
              }).catch(res => {
                const h = this.$createElement;
                that.$notify({
                  title: "提示信息",
                  message: h("i", { style: "color: #F56C6C" }, res),
                  duration: 2000
                });
              })
              const h = this.$createElement;
              that.$notify({
                title: "德运通天然气信息管理系统欢迎您",
                message: h("i", { style: "color: #67C23A" }, res.data.msg),
                duration: 2000
              });
            }
           }
          )
      }

    },
    warn(){
      if(this.getViewportSize().width<1100){
        const h = this.$createElement;
        this.$notify({
          title: "提示信息",
          message: h("i", { style: "color: #E6A23C" }, "pc端版本请在电脑操作使用"),
          duration: 2000
        });
      }
    },
    message() {
      const h = this.$createElement;
      this.$notify({
        title: "德运通天然气信息管理系统欢迎您",
        message: h("i", { style: "color: teal" }, "请输入您的账号与密码"),
        duration: 4000
      });
    },
    // 打开找回密码
    openForget () {
      this.formDialog = true;
      this.form.username = '';
      this.form.email = '';
      this.$nextTick(()=>{
        this.$refs['formforget'].clearValidate();
      })
    },
    onSubmit (form) { // 找回密码
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.$axios.post( api.uaa.resetPwd, this.form ).then(res => {
            if(res.data.code === 200){
              const h = this.$createElement;
              that.$notify({
                title: "提示信息",
                message: h("i", { style: "color: #67C23A" }, res.data.msg),
                duration: 2000
              });
              this.formDialog = false;
            }
          });
        }
      })
    },
  },
  mounted() {
    this.message();
    this.warn()
  }
};
</script>
<style lang="scss">
  #login .el-dialog__body {
    padding: 5px 20px !important;
  }
  #login .el-dialog__footer {
    padding: 0px 20px 20px 0 !important;
  }
#login {
  width: 100%;
  height: 100%;
  background-color: #2d3a4b;
  .loginConbox {
    background: #2d3a4b;
  }
  .header {
    height: 60px;
    position: relative;
    background: #2d3a4b;
    /*border-bottom: 1px solid rgba(255, 255, 255, 0.3);*/
    .logo {
      margin-left: 30px;
      width: 500px;
      float: left;
      height: 40px;
      padding-top: 10px;
      img {
        height: 100%;
      }
    }
  }

  .loginBox {
    .iconcolor {
      color: #409eff;
    }
    margin:0 auto;position: fixed;width:100%;height: 388px;top: calc(50% - 260px);

    .loginCon {
      width:62%; margin: 0 auto;height: 388px;
      .logo-box{float: left;width:44%;height:388px;display: flex;align-items: center;justify-content: center}
      .logo-box img {width:100%;height:auto; }
      .el-card__header {
        border-bottom: 0px;
      }
      .login-con-box{ width:40%;max-width:400px;height: 100%;float: right;}
      .title {  width:100%;text-align: center; font-size: 33px!important; font-weight: 600; color: #ffffff; margin-bottom: 20px!important; }
      .login-module {
        width:88%; height:290px;border-radius:5px; background: #fff;margin: 10px auto;padding: 0 6%;
        /*margin-top: 60px;*/
        /*position: absolute;
        top: 50px;
        right: 0;*/

        .formTitlt {width: 100%;line-height:50px;font-size: 18px; font-weight: 400;margin-bottom: 20px}

        .smalltxt {
          text-align: right;
          a {
            cursor: pointer;
            text-decoration: none;
            color: #999999;
            font-size: 12px;
            margin-left: 8px;
          }
        }
      }

      .el-form-item__content {
        margin-left: 0px !important;

        .subBtn {
          width: 100%;
        }
      }
    }


    .el-form-item__content .ico {
      position: absolute;
      top: 0px;
      left: 0px;
      z-index: 999;
      width: 40px;
      height: 39px;
      text-align: center;
      border-right: 1px solid #ccc;
    }

    .ewmbox {
      width: 100%;
      height: 240px;
      margin-top: -25px;

      .ewm {
        width: 140px;
        height: 140px;
        margin: 2px 0px 20px 75px;

        p {
          font-size: 12px;
          padding-left: 40px;
          margin: 0;
        }
      }

      .ewmicon {
        width: 140px;
        margin: 20px auto 0;

        .iconfont {
          float: left;
        }

        p {
          font-size: 12px;
          padding-left: 40px;
          margin: 0;
        }
      }
    }
  }
  .el-form-item, .el-form--inline .el-form-item{margin-bottom: 22px!important;}
}
</style>



// WEBPACK FOOTER //
// src/pages/login/index.vue